import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { JVDate } from "../../shared/JVDate";
import { JVInput } from "../../shared/JVInput";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ITimesheet } from "../../models/Timesheet";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { BillingCycle, IPurchaseOrder } from "../../models/PurchaseOrder";
import { ILogin } from "../../models/Login";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { JVCheckbox } from "../../shared/JVCheckbox";

interface IProps {
  po: IPurchaseOrder;
  recent?: ITimesheet;
  leftTimesheetDates: string[],
  onSave: () => void,
}

const schema = yup.object({
  fromDate: yup.date().required("From Date is required").typeError("From Date is required"),
  toDate: yup.date().required("To Date is required").typeError("To Date is required"),
  workHours: yup.string().required("Work Hours is required"),
  overlapWorkHours: yup.number().max(60).nullable(),
  // timeSheet_Path: yup.string().required("TimesSheet is required"),
  isNotWorking: yup.boolean().nullable(),
  comments: yup.string().nullable(),
});

export const AddConsultantTimeSheet = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [timeSheetFile, setTimeSheetFile] = useState<File | null | any>(null);
  const [recentTimesheet, setRecentTimesheet] = useState<ITimesheet>({});
  const [maxIndex, setMaxIndex] = useState<number>(0);
  const [disableAllField, setDisableAllField] = useState(false);
  const [workHoursHeader, setWorkHoursHeader] = useState<string>("Work Hours");
  const [overlapHoursHeader, setOverlapHoursHeader] = useState<string>("Overlaping Hours");
  const [showOverlap, setShowOverlap] = useState<boolean>(false);
  const [openRules, setOpenRules] = useState<boolean>(false);

  const toast = useRef<any>(null);

  const { control, handleSubmit, formState: { errors }, reset, setValue, watch, } = useForm<ITimesheet>({
    resolver: yupResolver(schema),
    defaultValues: {},
    shouldFocusError: false,
  });

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");

  const fileUploade = (event: FileUploadHandlerParam) => {
    if (event.files[0].size > 1024 * 1024 * 5) {
      toast.current.show({ severity: "error", content: "Document should be less than 5 MB.", });
      event.options.clear();
    } else {
      setTimeSheetFile(event.files[0]);
      toast.current.show({ severity: "success", content: "File Selected", });
      event.options.clear();
    }
  };

  // const uploadeFile = async (file: File) => {
  //     setLoading(true);
  //     let formData = new FormData();
  //     formData.append("file", file);

  //     const params = {
  //         method: "props.poST",
  //         headers: {
  //             'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
  //         },
  //         body: formData
  //     };
  //     const resprops.ponse = await fetch(`${baseUrl}Ticket/file`, params);
  //     if (resprops.ponse) {
  //         const data = await resprops.ponse.text();
  //         setValue("timeSheet_Path", data);
  //         toast.current.show({ severity: 'success', content: `Document Uploaded Successfully as -"${data}"` });
  //     }
  //     setLoading(false);
  // }

  const onSubmit = (data: ITimesheet) => {
    // data.consultant_ID = props.singleData.consultant_ID;
    // data.props.po_ID = props.singleData.props.po_ID;
    const toDate = new Date(data.toDate || "");
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (toDate > today) {
      toast.current.show({ severity: 'error', content: `Week not ended yet` });
    } else if (timeSheetFile === null && (data.isNotWorking !== true)) {
      toast.current.show({ severity: "error", content: `Please Select A File`, });
    } else {
      if ((Number(data?.workHours || "0") + Number(data?.overlapWorkHours || "0")) <= 0 && data.isNotWorking !== true) {
        toast.current.show({ severity: 'error', content: `Working Hours must be greater than 0 and less than 90` });
      } else if ((Number(data?.workHours || "0") + Number(data?.overlapWorkHours || "0")) > 90) {
        toast.current.show({ severity: 'error', content: `Working Hours can not be greater than 90` });
      } else {
        saveToDB(data);
      }
    }
  };

  const saveToDB = async (data: ITimesheet) => {
    if (typeof Number(data.workHours) !== 'number' && data.isNotWorking !== true) {
      toast.current.show({ severity: 'error', detail: "Working Hours Must Be In Numbers", life: 3000 });
    } else {
      setLoading(true);
      let body: any = data;
      body.pO_ID = props.po.pO_ID;
      body.consultant_ID = props?.po?.consultant_ID;
      body.workHours = Number(data.workHours);

      const method = "POST";
      const message = "Added Successfully";
      let extraQuery = "";
      if (loginObj.user_Type === 2) {
        extraQuery = `consultantUser=${loginObj.consultant_ID}&userType=${loginObj.user_Type}`;
      }

      if (loginObj.user_Type === 3) {
        extraQuery = `subvendorUser=${loginObj.sub_Vendor_ID}&userType=${loginObj.user_Type}`;
      }

      const formData = new FormData();
      formData.append("file", timeSheetFile);
      formData.append("timesheet", JSON.stringify(body));
      //formData.append('userType', `${loginObj.user_Type}`);
      //formData.append('userID', `${loginObj.user_Type === 2 ? loginObj.consultant_ID : loginObj.sub_Vendor_ID}`);
      const params = {
        method: method,
        headers: { Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`, },
        body: formData,
      };
      const response = await fetch(`${baseUrl}ResourceTimesheet${data.isNotWorking === true ? "/notWorkingTimesheet" : ""}?${extraQuery}`, params);

      //const resprops.ponse = await Fetch("Timesheet", method, data, null, toast);
      if (response) {
        setDisableAllField(false);
        setTimeSheetFile(null);
        toast.current.show({ severity: "success", detail: message, life: 3000, });
        props.onSave();
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
  };

  const onHide = () => {
    setDisableAllField(false);
    setTimeSheetFile(null);
    if (props.leftTimesheetDates.length > 0 && maxIndex !== 0) {
      const fromDate = new Date(props.leftTimesheetDates[maxIndex] || "");
      const currentDate = new Date(props.leftTimesheetDates[maxIndex] || "");
      let numberOfDaysToAdd = 7 - Number(new Date(props.leftTimesheetDates[maxIndex] || "")?.getDay());
      const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
      console.log(1);
      reset({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });
    } else if (props.leftTimesheetDates.length > 0 && (props.leftTimesheetDates.length > 0 ? maxIndex === 0 : true) && recentTimesheet.toDate !== undefined) {
      const fromDate = new Date(props.leftTimesheetDates[0] || "");
      const currentDate = new Date(props.leftTimesheetDates[0] || "");
      let numberOfDaysToAdd = 7 - Number(new Date(props.leftTimesheetDates[0] || "")?.getDay());
      const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
      console.log(2);
      reset({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });
    } else if (recentTimesheet.toDate === undefined) {
      const fromDate = new Date(props.po?.project_Start_Date || "");
      const currentDate = new Date(props.po?.project_Start_Date || "");
      let numberOfDaysToAdd = 7 - Number(new Date(props.po?.project_Start_Date || "")?.getDay());
      const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
      console.log(3);
      reset({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });

    } else if (recentTimesheet?.toDate && recentTimesheet?.toDate !== null) {
      const date = new Date(recentTimesheet?.toDate || "");
      const currentDay = date.getDay();

      // Calculate the number of days to add to get to the next Monday
      const daysToAdd = currentDay === 0 ? 1 : 8 - currentDay;

      // Add the days to the current date
      date.setDate(date.getDate() + daysToAdd);

      // Return the new date in YYYY-MM-DD format
      // return date.toISOString().split('T')[0];

      const fromDate = new Date(date.toISOString());
      // props.singleData.fromDate = fromDate;
      const toDate = new Date(new Date(fromDate || "").setDate(new Date(fromDate || "").getDate() + 6));
      // props.singleData.toDate = toDate;
      console.log(4);
      reset({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });
    }
  };

  const setLatest = () => {
    if (props.leftTimesheetDates.length > 0) {
      setMaxIndex(0);
      const fromDate = new Date(props.leftTimesheetDates[0] || "");
      const currentDate = new Date(props.leftTimesheetDates[0] || "");
      let numberOfDaysToAdd = 7 - Number(new Date(props.leftTimesheetDates[0] || "")?.getDay());
      const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
      console.log(5);
      reset({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });
    } else if (recentTimesheet?.toDate === null) {
      const currentDate = new Date(props.po?.project_Start_Date || "");
      let numberOfDaysToAdd = 7 - Number(new Date(props.po?.project_Start_Date || "")?.getDay());
      const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
      console.log(6);
      reset({ fromDate: currentDate, toDate: toDate, workHours: undefined, comments: undefined });

    } else if (recentTimesheet?.toDate && recentTimesheet?.toDate !== null) {
      const date = new Date(recentTimesheet?.toDate || "");
      const currentDay = date.getDay();
      const daysToAdd = currentDay === 0 ? 1 : 8 - currentDay;
      date.setDate(date.getDate() + daysToAdd);
      const fromDate = new Date(date.toISOString());
      const toDate = new Date(new Date(fromDate || "").setDate(new Date(fromDate || "").getDate() + 6));
      console.log(7);
      reset({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });
    }
  };

  const nextBtn = () => {
    if (props.leftTimesheetDates.length === maxIndex + 1) {
      if (recentTimesheet?.toDate && recentTimesheet?.toDate !== null) {
        const weekStartDay = props?.po?.timesheet_Week_Start_Day || 0;
        const date = new Date(recentTimesheet?.toDate || "");
        const currentDay = date.getDay();
        const daysToAdd = currentDay === 0 ? 1 : 8 - currentDay;
        date.setDate(date.getDate() + daysToAdd);
        const fromDate = new Date(date.toISOString());
        let numberOfDaysToAdd = (weekStartDay - Number(fromDate?.getDay()) + 7) % 7;
        const toDate = new Date(new Date(fromDate || "").setDate(new Date(fromDate || "").getDate() + numberOfDaysToAdd));
        // console.log(recentTimesheet);
        // console.log({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });
        console.log(8);
        reset({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });

        if (new Date(fromDate || "").getMonth() + 1 !== new Date(toDate || "").getMonth() + 1) {
          setShowOverlap(true);
          const lastDateOfFrom = new Date(new Date(fromDate || "").getFullYear(), new Date(fromDate || "").getMonth() + 1, 0);
          const firstDateOfTo = new Date(new Date(toDate || "").getFullYear(), new Date(toDate || "").getMonth(), 1);
          setWorkHoursHeader(`Work Hours : (${new Date(fromDate || "").getDate()}-${new Date(fromDate || "").getMonth() + 1}-${new Date(fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
          setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDate || "").getDate()}-${new Date(toDate || "").getMonth() + 1}-${new Date(toDate || "").getFullYear()})`);
        } else if (new Date(fromDate || "").getMonth() + 1 === new Date(toDate || "").getMonth() + 1) {
          setWorkHoursHeader("Work Hours");
          setOverlapHoursHeader("Overlaping Hours");
          setValue('overlapWorkHours', 0);
          setShowOverlap(false);
        } else {
          setShowOverlap(false);
          setWorkHoursHeader(`Work Hours`);
          setOverlapHoursHeader(`Overlaping Hours`);
        }

        if ((props.po?.sub_Vendor_Billing_Cycle === BillingCycle.SemiMonthly || props.po?.prime_Vendor_Billing_Cycle === BillingCycle.SemiMonthly) && new Date(fromDate || "").getDate() < 16 && new Date(toDate || "").getDate() >= 16) {
          setShowOverlap(true);
          const lastDateOfFrom = new Date(new Date(fromDate || "").getFullYear(), new Date(fromDate || "").getMonth(), 15);
          const firstDateOfTo = new Date(new Date(toDate || "").getFullYear(), new Date(toDate || "").getMonth(), 16);
          setWorkHoursHeader(`Work Hours : (${new Date(fromDate || "").getDate()}-${new Date(fromDate || "").getMonth() + 1}-${new Date(fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
          setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDate || "").getDate()}-${new Date(toDate || "").getMonth() + 1}-${new Date(toDate || "").getFullYear()})`);
        } else {
          setShowOverlap(false);
          setWorkHoursHeader(`Work Hours`);
          setOverlapHoursHeader(`Overlaping Hours`);
        }
      }
    } else {
      setMaxIndex(prev => prev = prev + 1);
    }
  };

  const GetRecentTimesheets = async () => {
    let extraQuery = "";

    const response = await Fetch("ResourceTimesheet", "GET", null, `byConsultant=0&byPO_ID=${props.po?.pO_ID}` + extraQuery, null);
    if (response) {
      const data = await response.json();

      setRecentTimesheet(data[0] || {});
    }
  };

  useEffect(() => {
    if (maxIndex !== 0) {
      const weekStartDay = props?.po?.timesheet_Week_Start_Day || 0;
      const fromDate = new Date(props.leftTimesheetDates[maxIndex] || "");
      const currentDate = new Date(props.leftTimesheetDates[maxIndex] || "");
      //let numberOfDaysToAdd = 7 - Number(new Date(props.leftTimesheetDates[maxIndex] || "")?.getDay());
      let numberOfDaysToAdd = (weekStartDay - Number(new Date(props?.leftTimesheetDates[maxIndex] || "")?.getDay()) + 7) % 7;
      const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
      console.log(9);
      reset({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });

      if (new Date(fromDate || "").getMonth() + 1 !== new Date(toDate || "").getMonth() + 1) {
        setShowOverlap(true);
        const lastDateOfFrom = new Date(new Date(fromDate || "").getFullYear(), new Date(fromDate || "").getMonth() + 1, 0);
        const firstDateOfTo = new Date(new Date(toDate || "").getFullYear(), new Date(toDate || "").getMonth(), 1);
        setWorkHoursHeader(`Work Hours : (${new Date(fromDate || "").getDate()}-${new Date(fromDate || "").getMonth() + 1}-${new Date(fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
        setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDate || "").getDate()}-${new Date(toDate || "").getMonth() + 1}-${new Date(toDate || "").getFullYear()})`);
      } else if (new Date(fromDate || "").getMonth() + 1 === new Date(toDate || "").getMonth() + 1) {
        setWorkHoursHeader("Work Hours");
        setOverlapHoursHeader("Overlaping Hours");
        setValue('overlapWorkHours', 0);
        setShowOverlap(false);
      } else {
        setShowOverlap(false);
        setWorkHoursHeader(`Work Hours`);
        setOverlapHoursHeader(`Overlaping Hours`);
      }

      if ((props.po?.sub_Vendor_Billing_Cycle === BillingCycle.SemiMonthly || props.po?.prime_Vendor_Billing_Cycle === BillingCycle.SemiMonthly) && new Date(fromDate || "").getDate() < 16 && new Date(toDate || "").getDate() >= 16) {
        setShowOverlap(true);
        const lastDateOfFrom = new Date(new Date(fromDate || "").getFullYear(), new Date(fromDate || "").getMonth(), 15);
        const firstDateOfTo = new Date(new Date(toDate || "").getFullYear(), new Date(toDate || "").getMonth(), 16);
        setWorkHoursHeader(`Work Hours : (${new Date(fromDate || "").getDate()}-${new Date(fromDate || "").getMonth() + 1}-${new Date(fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
        setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDate || "").getDate()}-${new Date(toDate || "").getMonth() + 1}-${new Date(toDate || "").getFullYear()})`);
      } else {
        setShowOverlap(false);
        setWorkHoursHeader(`Work Hours`);
        setOverlapHoursHeader(`Overlaping Hours`);
      }
    }
  }, [maxIndex]);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "fromDate") {
        if (value.fromDate != null) {
          const dayOfWeek = value.fromDate.getDay();
          if (dayOfWeek === 0) {
            setValue('toDate', value.fromDate);
            setWorkHoursHeader("Work Hours");
            setOverlapHoursHeader("Overlaping Hours");
            setValue('overlapWorkHours', 0);
            setShowOverlap(false);
          } else {
            setValue('toDate', new Date(new Date(value.fromDate).setDate(new Date(value.fromDate).getDate() + ((6 - dayOfWeek) + 1))));

            const toDateIs: Date = new Date(new Date(value.fromDate).setDate(new Date(value.fromDate).getDate() + ((6 - dayOfWeek) + 1)));

            if (new Date(value.fromDate || "").getMonth() + 1 !== new Date(toDateIs || "").getMonth() + 1) {
              setShowOverlap(true);
              const lastDateOfFrom = new Date(new Date(value.fromDate || "").getFullYear(), new Date(value.fromDate || "").getMonth() + 1, 0);
              const firstDateOfTo = new Date(new Date(toDateIs || "").getFullYear(), new Date(toDateIs || "").getMonth(), 1);
              setWorkHoursHeader(`Work Hours : (${new Date(value.fromDate || "").getDate()}-${new Date(value.fromDate || "").getMonth() + 1}-${new Date(value.fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
              setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDateIs || "").getDate()}-${new Date(toDateIs || "").getMonth() + 1}-${new Date(toDateIs || "").getFullYear()})`);
            } else if (new Date(value.fromDate || "").getMonth() + 1 === new Date(toDateIs || "").getMonth() + 1) {
              setWorkHoursHeader("Work Hours");
              setOverlapHoursHeader("Overlaping Hours");
              setValue('overlapWorkHours', 0);
              setShowOverlap(false);
            } else if ((props.po?.sub_Vendor_Billing_Cycle === BillingCycle.SemiMonthly || props.po?.prime_Vendor_Billing_Cycle === BillingCycle.SemiMonthly) && new Date(value.fromDate || "").getDate() < 16 && new Date(toDateIs || "").getDate() >= 16) {
              setShowOverlap(true);
              const lastDateOfFrom = new Date(new Date(value.fromDate || "").getFullYear(), new Date(value.fromDate || "").getMonth(), 15);
              const firstDateOfTo = new Date(new Date(toDateIs || "").getFullYear(), new Date(toDateIs || "").getMonth(), 16);
              setWorkHoursHeader(`Work Hours : (${new Date(value.fromDate || "").getDate()}-${new Date(value.fromDate || "").getMonth() + 1}-${new Date(value.fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
              setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDateIs || "").getDate()}-${new Date(toDateIs || "").getMonth() + 1}-${new Date(toDateIs || "").getFullYear()})`);
            } else {
              setShowOverlap(false);
              setWorkHoursHeader(`Work Hours`);
              setOverlapHoursHeader(`Overlaping Hours`);
            }
          }
        }
      }
      if (name === "isNotWorking") {
        if (value.isNotWorking === true) {
          setValue("workHours", "0");
          setValue("overlapWorkHours", 0);
          setDisableAllField(prev => prev = true);
        } else setDisableAllField(prev => prev = false);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, workHoursHeader, overlapHoursHeader, showOverlap]);

  useEffect(() => {
    if (props.po?.pO_ID) {
      GetRecentTimesheets();
    }
  }, [props.po]);

  useEffect(() => {
    if (props.po?.pO_ID) {
      const weekStartDay = props?.po?.timesheet_Week_Start_Day || 0;
      if (props.leftTimesheetDates.length > 0 && recentTimesheet.toDate !== undefined) {
        console.log(1);
        const fromDate = new Date(props.leftTimesheetDates[0] || "");
        const currentDate = new Date(props.leftTimesheetDates[0] || "");
        //let numberOfDaysToAdd = 7 - Number(new Date(props.leftTimesheetDates[0] || "")?.getDay());
        let numberOfDaysToAdd = (weekStartDay - Number(new Date(props?.leftTimesheetDates[0] || "")?.getDay()) + 7) % 7;
        const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
        console.log(10);
        reset({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });

        if (new Date(fromDate || "").getMonth() + 1 !== new Date(toDate || "").getMonth() + 1) {
          setShowOverlap(true);
          const lastDateOfFrom = new Date(new Date(fromDate || "").getFullYear(), new Date(fromDate || "").getMonth() + 1, 0);
          const firstDateOfTo = new Date(new Date(toDate || "").getFullYear(), new Date(toDate || "").getMonth(), 1);
          setWorkHoursHeader(`Work Hours : (${new Date(fromDate || "").getDate()}-${new Date(fromDate || "").getMonth() + 1}-${new Date(fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
          setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDate || "").getDate()}-${new Date(toDate || "").getMonth() + 1}-${new Date(toDate || "").getFullYear()})`);
        } else if ((props.po?.sub_Vendor_Billing_Cycle === BillingCycle.SemiMonthly || props.po?.prime_Vendor_Billing_Cycle === BillingCycle.SemiMonthly) && new Date(fromDate || "").getDate() < 16 && new Date(toDate || "").getDate() >= 16) {
          setShowOverlap(true);
          const lastDateOfFrom = new Date(new Date(fromDate || "").getFullYear(), new Date(fromDate || "").getMonth(), 15);
          const firstDateOfTo = new Date(new Date(toDate || "").getFullYear(), new Date(toDate || "").getMonth(), 16);
          setWorkHoursHeader(`Work Hours : (${new Date(fromDate || "").getDate()}-${new Date(fromDate || "").getMonth() + 1}-${new Date(fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
          setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDate || "").getDate()}-${new Date(toDate || "").getMonth() + 1}-${new Date(toDate || "").getFullYear()})`);
        } else {
          setShowOverlap(false);
          setWorkHoursHeader(`Work Hours`);
          setOverlapHoursHeader(`Overlaping Hours`);
        }
      } else if (recentTimesheet.toDate === undefined) {
        const fromDate = new Date(props.po?.project_Start_Date || "");
        const currentDate = new Date(props.po?.project_Start_Date || "");
        //let numberOfDaysToAdd = 7 - Number(new Date(props.po?.project_Start_Date || "")?.getDay());
        let numberOfDaysToAdd = (weekStartDay - Number(new Date(props?.po?.project_Start_Date || "")?.getDay()) + 7) % 7;
        const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
        console.log(11);
        reset({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });

        if (new Date(fromDate || "").getMonth() + 1 !== new Date(toDate || "").getMonth() + 1) {
          setShowOverlap(true);
          const lastDateOfFrom = new Date(new Date(fromDate || "").getFullYear(), new Date(fromDate || "").getMonth() + 1, 0);
          const firstDateOfTo = new Date(new Date(toDate || "").getFullYear(), new Date(toDate || "").getMonth(), 1);
          setWorkHoursHeader(`Work Hours : (${new Date(fromDate || "").getDate()}-${new Date(fromDate || "").getMonth() + 1}-${new Date(fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
          setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDate || "").getDate()}-${new Date(toDate || "").getMonth() + 1}-${new Date(toDate || "").getFullYear()})`);
        } else if ((props.po?.sub_Vendor_Billing_Cycle === BillingCycle.SemiMonthly || props.po?.prime_Vendor_Billing_Cycle === BillingCycle.SemiMonthly) && new Date(fromDate || "").getDate() < 16 && new Date(toDate || "").getDate() >= 16) {
          setShowOverlap(true);
          const lastDateOfFrom = new Date(new Date(fromDate || "").getFullYear(), new Date(fromDate || "").getMonth(), 15);
          const firstDateOfTo = new Date(new Date(toDate || "").getFullYear(), new Date(toDate || "").getMonth(), 16);
          setWorkHoursHeader(`Work Hours : (${new Date(fromDate || "").getDate()}-${new Date(fromDate || "").getMonth() + 1}-${new Date(fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
          setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDate || "").getDate()}-${new Date(toDate || "").getMonth() + 1}-${new Date(toDate || "").getFullYear()})`);
        } else {
          setShowOverlap(false);
          setWorkHoursHeader(`Work Hours`);
          setOverlapHoursHeader(`Overlaping Hours`);
        }

      } else if (recentTimesheet?.toDate && recentTimesheet?.toDate !== null) {
        const date = new Date(recentTimesheet?.toDate || "");
        const currentDay = date.getDay();

        // Calculate the number of days to add to get to the next Monday
        const daysToAdd = currentDay === 0 ? 1 : 8 - currentDay;

        // Add the days to the current date
        date.setDate(date.getDate() + daysToAdd);

        // Return the new date in YYYY-MM-DD format
        // return date.toISOString().split('T')[0];

        const fromDate = new Date(date.toISOString());
        let numberOfDaysToAdd = (weekStartDay - Number(fromDate?.getDay()) + 7) % 7;
        // props.singleData.fromDate = fromDate;
        const toDate = new Date(new Date(fromDate || "").setDate(new Date(fromDate || "").getDate() + numberOfDaysToAdd));
        // props.singleData.toDate = toDate;
        console.log(12);
        reset({ fromDate: fromDate, toDate: toDate, workHours: undefined, comments: undefined });
        if (new Date(fromDate || "").getMonth() + 1 !== new Date(toDate || "").getMonth() + 1) {
          setShowOverlap(true);
          const lastDateOfFrom = new Date(new Date(fromDate || "").getFullYear(), new Date(fromDate || "").getMonth() + 1, 0);
          const firstDateOfTo = new Date(new Date(toDate || "").getFullYear(), new Date(toDate || "").getMonth(), 1);
          setWorkHoursHeader(`Work Hours : (${new Date(fromDate || "").getDate()}-${new Date(fromDate || "").getMonth() + 1}-${new Date(fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
          setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDate || "").getDate()}-${new Date(toDate || "").getMonth() + 1}-${new Date(toDate || "").getFullYear()})`);
        } else {
          setShowOverlap(false);
          setWorkHoursHeader(`Work Hours`);
          setOverlapHoursHeader(`Overlaping Hours`);
        }

        if ((props.po?.sub_Vendor_Billing_Cycle === BillingCycle.SemiMonthly || props.po?.prime_Vendor_Billing_Cycle === BillingCycle.SemiMonthly) && new Date(fromDate || "").getDate() < 16 && new Date(toDate || "").getDate() >= 16) {
          setShowOverlap(true);
          const lastDateOfFrom = new Date(new Date(fromDate || "").getFullYear(), new Date(fromDate || "").getMonth(), 15);
          const firstDateOfTo = new Date(new Date(toDate || "").getFullYear(), new Date(toDate || "").getMonth(), 16);
          setWorkHoursHeader(`Work Hours : (${new Date(fromDate || "").getDate()}-${new Date(fromDate || "").getMonth() + 1}-${new Date(fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
          setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDate || "").getDate()}-${new Date(toDate || "").getMonth() + 1}-${new Date(toDate || "").getFullYear()})`);
        } else {
          setShowOverlap(false);
          setWorkHoursHeader(`Work Hours`);
          setOverlapHoursHeader(`Overlaping Hours`);
        }
      }
    }
    // console.log(props.po);

  }, [recentTimesheet]);

  return (
    <>
      <div className="w-full flex flex-row-reverse"><Button icon="pi pi-info-circle" tooltip="Help" onClick={() => setOpenRules(true)} /></div>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
        <JVDate required column={6} maxDate={new Date()} label="From Date" control={control} name="fromDate" error={errors.fromDate?.message} />
        <JVDate required column={6} maxDate={new Date()} disabled label="To Date" control={control} name="toDate" error={errors.toDate?.message} />
        <JVInput required column={4} label={workHoursHeader} disabled={disableAllField} control={control} name="workHours" error={errors.workHours?.message} />
        {showOverlap && <JVInput required column={3} label={overlapHoursHeader} disabled={disableAllField && showOverlap} control={control} name="overlapWorkHours" error={errors.overlapWorkHours?.message} />}
        <JVInput column={3} label="Comment" control={control} name="comments" error={errors.comments?.message} />
        <div className="field col-12 md:col-1 pt-5">
          <JVCheckbox column={1} label="Not Worked" control={control} name="isNotWorking" />
        </div>
        <div className="field col-12 md:col-2">
          <label htmlFor="file">TimeSheet<span style={{ color: "red" }}>*</span></label>
          <FileUpload chooseLabel="Choose File" disabled={disableAllField} mode="basic" name="file" accept="*" maxFileSize={10000000} customUpload auto uploadHandler={fileUploade} />
          {errors.timeSheet_Path?.message && (
            <small className="p-error">{errors.timeSheet_Path?.message}</small>
          )}
        </div>
        {/* <div style={{border: "1px solid red", width: "100%", marginTop: "3rem"}}></div> */}
        <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-3">
          <Button loading={loading} style={{ width: '100px' }} label="SAVE" type="submit"></Button>
          <Button style={{ height: "33px", width: "100px" }} label="SKIP" onClick={() => nextBtn()} ></Button>
          <Button style={{ width: '100px' }} label="CLEAR" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
        </div>
      </form>
      <Dialog visible={openRules} style={{ width: '80vw' }} header="Help — Add/Update Consultant Timesheet" modal className="p-fluid" onHide={() => setOpenRules(false)}>
        <div className="mission-header">
          <hr />
          <h2>🗓️ 1. From Date & To Date</h2>
          <p style={{ fontWeight: "bold" }}>- These fields define the start and end dates of the week for which you are submitting your timesheet.</p>
          <p style={{ fontWeight: "bold" }}>- Example:</p>
          <p className="pl-5">    - From Date: 06-30-2025</p>
          <p className="pl-5">    - To Date: 07-06-2025</p>
          <p>⚠️ Make sure the selected dates represent a valid weekly range.</p>
          <hr />
          <h2>⏰ 2. Work Hours</h2>
          <p style={{ fontWeight: "bold" }}>- This field is for entering total work hours between the From Date and To Date. (max 90 Hrs)</p>
          <p style={{ fontWeight: "bold" }}>- Example: 40 hours or 8 hours per day.</p>
          <p style={{ fontWeight: "bold" }}>- If the selected dates span two different months:</p>
          <p className="pl-5">- The system automatically divides the week into two parts:</p>
          <p className="pl-5">    - Work Hours → For the period within the From Date’s month</p>
          <p className="pl-5">    - Overlap Hours → For the period that falls into the To Date’s month</p>
          <p style={{ fontWeight: "bold" }}>- Example:</p>
          <p className="pl-5">    - From Date: 06-30-2025</p>
          <p className="pl-5">    - To Date: 07-06-2025</p>
          <p className="pl-5">    - You’ll see two fields:</p>
          <p className="pl-5"><p className="pl-5"> - Work Hours (06-30-2025 to 06-30-2025)</p></p>
          <p className="pl-5"><p className="pl-5"> - Overlap Hours (01-06-2025 to 07-06-2025)</p></p>
          <hr />
          <h2>📎 3. Timesheet Upload</h2>
          <p style={{ fontWeight: "bold" }}>- Use the “+ Choose File” button to upload your completed timesheet file (e.g., PDF, Excel, or image).</p>
          <p style={{ fontWeight: "bold" }}>- Ensure the uploaded file corresponds to the selected date range.</p>
          <hr />
          <h2>🚫 4. Not Worked Checkbox</h2>
          <p style={{ fontWeight: "bold" }}>- If you did not work during the selected period:</p>
          <p className="pl-5">    - Check the “Not Worked” box.</p>
          <p className="pl-5">    - All “Work Hours” and “Overlap Hours” input fields and the upload button will be disabled automatically.</p>
          <p className="pl-5">    - No need to upload a timesheet file.</p>
          <hr />
          <h2>💬 5. Comment</h2>
          <p style={{ fontWeight: "bold" }}>- Use this field to provide any additional information or clarification related to your timesheet.</p>
          <p style={{ fontWeight: "bold" }}>- Example:</p>
          <p className="pl-5">    - “Was on leave for 2 days due to illness.”</p>
          <p className="pl-5">    - “Worked extra hours on Friday.”</p>
          <hr />
          <h2>💾 6. Save & Close</h2>
          <p style={{ fontWeight: "bold" }}>- SAVE → Click this button to submit or update your timesheet details.</p>
          <p style={{ fontWeight: "bold" }}>- CLOSE → Exit the form without saving changes.</p>
          <hr />
        </div>
      </Dialog>
      <Toast ref={toast} />
    </>
  );
};
